import { SelectionEntry } from "@app/components/core/SelectionEntry/SelectionEntry"
import { getPriceString } from "@app/utils/localeUtils"

const BluphoriaSelector = ({ imgSrc, count, onClick, name, volume, entity, baseEntity, basePrice, price, onAdd, onRemove, expanded, plusDisabled }) => {
	return (
		<SelectionEntry
			count={count}
			onClick={onClick}
			imgSrc={imgSrc}
			onAdd={onAdd}
			onRemove={onRemove}
			squareImage
			expanded={expanded}
			plusDisabled={plusDisabled}
			ariaLabel={name}
		>
			<div className="f4 f-lg-3 color-fg-primary flex flex-items-center">{name}</div>
			{volume ? (
				<div className="f5 f-lg-4 color-fg-primary">
					{volume} {entity}
				</div>
			) : null}
			<div className="f5 color-fg-secondary semibold">{getPriceString(price, undefined, false)}</div>
			{basePrice && baseEntity ? (
				<div className="f6 color-fg-secondary semibold">
					{getPriceString(basePrice, undefined, false)} / 1 {baseEntity}
				</div>
			) : (
				<div />
			)}
		</SelectionEntry>
	)
}

export { BluphoriaSelector }
